module.exports = __webpack_public_path__ + "img/max-file-subtract.d18448f5.svg";